import { useNavigate } from "react-router-dom";
import { format as formatDate } from "../../../common/services/common.service";
import moment from "moment";

export const CalendarList = ({
	subscriptions
}: any) => {
	const navigate = useNavigate();
	// const subscriptions = [
	// 	{
	// 		title: "Michael Lee - Breakfast",
	// 		description: [{ ItemName: "Oatmeal with Berries", Quantity: 1 },
	// 		{ ItemName: "Orange Juice(250ml)", Quantity: 2 }],
	// 		price: "120.99",
	// 		frequency: "Monthly",
	// 		startDate: "2025-05-01",
	// 		endDate: "2025-06-01",
	// 		status: "active",
	// 		actionText: "Manage",
	// 	},
	// 	{
	// 		title: "John Peter - Special Meal",
	// 		description: [{ ItemName: "Avocado Toast", Quantity: 1 },
	// 		{ ItemName: "Green Smoothie", Quantity: 2 }],
	// 		price: "130.99",
	// 		frequency: "Weekly",
	// 		startDate: "2025-04-01",
	// 		endDate: "2025-04-08",
	// 		status: "expired",
	// 		actionText: "Renew",
	// 	},
	// 	{
	// 		title: "Michael Lee - Breakfast",
	// 		description: [{ ItemName: "Oatmeal with Berries", Quantity: 1 },
	// 		{ ItemName: "Orange Juice(250ml)", Quantity: 2 }],
	// 		price: "120.99",
	// 		frequency: "Monthly",
	// 		startDate: "2025-05-01",
	// 		endDate: "2025-06-01",
	// 		status: "active",
	// 		actionText: "Manage",
	// 	},
	// 	{
	// 		title: "John Peter - Special Meal",
	// 		description: [{ ItemName: "Avocado Toast", Quantity: 1 },
	// 		{ ItemName: "Green Smoothie", Quantity: 2 }],
	// 		price: "130.99",
	// 		frequency: "Weekly",
	// 		startDate: "2025-04-01",
	// 		endDate: "2025-04-08",
	// 		status: "expired",
	// 		actionText: "Renew",
	// 	},
	// ];

	const onAction = (sub: any) => {
		alert(`${sub?.actionText} ${sub?.Title}`)
	}

	return (
		
		<div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-4">
  {subscriptions?.map((sub, idx) => (
    <div
      key={idx}
      className="bg-gradient-to-br from-white to-blue-50 rounded-2xl shadow-md border border-blue-200 hover:shadow-lg transition-all duration-300 p-6 relative"
    >
      {/* Decorative Left Stripe */}
      <div className="absolute left-0 top-0 h-full w-1 rounded-l-2xl bg-gradient-to-b from-blue-400 to-blue-600"></div>

      {/* Title */}
      <div className="text-center mb-4">
        <h4 className="text-lg font-bold text-blue-800">{sub?.Title}</h4>
      </div>

      {/* Details Table */}
      <table className="w-full text-sm text-left text-gray-700">
        <tbody>
          <tr className="border-b border-blue-100">
            <td className="py-2 font-medium w-1/4 text-gray-500">Start:</td>
            <td className="py-2 text-xs text-gray-800">
              {moment(sub?.StartDateOnUtc).format("DD-MMM-YY hh:mm A")}
            </td>
          </tr>
          <tr>
            <td className="py-2 font-medium text-gray-500">End:</td>
            <td className="py-2 text-xs text-gray-800">
              {moment(sub?.EndDateOnUtc).format("DD-MMM-YY hh:mm A")}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  ))}
</div>


	);
};